import { render, staticRenderFns } from "./CardDetailComponent.vue?vue&type=template&id=413e6ade"
import script from "./CardDetailComponent.vue?vue&type=script&lang=js"
export * from "./CardDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports